import { useMutation } from 'react-query'

import { APIError } from '../../../utils'
import { updateProductsVat as updateProductsVatQuery } from '../query-api'

export interface UseUpdateProductsVatProps {
  onSuccess?: () => void
  onError?: (error: APIError) => void
}

export const useUpdateProductsVat = ({ onSuccess, onError }: UseUpdateProductsVatProps) => {
  const { mutate, isLoading, ...rest } = useMutation(updateProductsVatQuery, {
    onError,
    onSuccess,
  })

  return { updateProductsVat: mutate, isLoading, ...rest }
}
